'use strict';

import Async from 'async';
import _ from 'lodash';

export default class UserPasswordModalController {
  /*@ngInject*/
  constructor($http, $q, $timeout, $uibModalInstance, user) {
    this.$http = $http;
    this.$q = $q;
    this.$timeout = $timeout;
    this.$uibModalInstance = $uibModalInstance;

    this.user = user;

    this.isAdd = true;
    this.form = {};
    this.submitted = false;
    this.isSaving = false;
    this.errors;
  }

  update(id, payload) {
    let self = this;
    this.$http.put(`/api/users/${id}/reset`, payload)
      .then(function(response) {
        self.$uibModalInstance.close();
      }, function(err) {
        self.isSaving = false;
        self.errors = {};
        angular.forEach(err.data.errors, (error, field) => {
          form[field].$setValidity('mongoose', false);
          self.errors[field] = error.message;
        });
      });
  }

  submitForm(form) {
    if(form.$valid) {
      let self = this;
      this.submitted = true;
      this.isSaving = true;
      if(this.user && this.user._id) {
        let payload = {
          password: this.form.confirmPassword
        };
        this.update(this.user._id, payload);
      }
    }
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  $onInit() {
    if(this.user && this.user._id) {
      this.isAdd = false;
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/admin/userPassword.modal.controller.js